module.exports = __webpack_public_path__ + "media/images/product_large_images/printer1(600)-6f0784d56e715e91dff6a04edb3274d7.png";